import flatpickr from "flatpickr";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import { Greek } from "flatpickr/dist/l10n/gr.js";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";
import { english } from "flatpickr/dist/l10n/default.js";

// I codici lingua dell'applicazione non coincidono con quelli di flatpickr:
// da noi lo spagnolo e' "sp" e il cinese "ch", per flatpickr sono "es" e "zh".
const LOCALES = {
  it: Italian,
  en: english,
  de: German,
  fr: French,
  sp: Spanish,
  pt: Portuguese,
  ru: Russian,
  ar: Arabic,
  gr: Greek,
  ch: Mandarin,
};

// Configurazioni comuni per flatpickr
// Sul telefono flatpickr, di suo, NON disegna il proprio calendario: mette al suo posto un
// <input type="date"> nativo. Sembra una cortesia e ci costa una regola: l'attributo "min" di
// quel campo lo scrive UNA VOLTA SOLA, alla creazione (setupMobile), e cambiando minDate dopo
// non lo tocca piu' — l'unica cosa che fa e' far saltare il calendario a quella data
// (CALLBACKS.minDate = [jumpToDate], flatpickr 4.6.13).
//
// Da noi il minimo arriva quasi sempre DOPO: e' il "dal" appena scelto che deve impedire di
// scegliere un "al" precedente. Alla creazione quel valore non c'e' ancora, quindi sul telefono
// il campo nasceva senza nessun limite e ci restava: sul PC la regola valeva, sul telefono si
// potevano scegliere date all'indietro.
//
// Con disableMobile il calendario e' sempre il suo, su qualunque schermo. Si perde la rotellina
// nativa del sistema; si guadagna che il limite vale davvero e che telefono e PC si comportano
// allo stesso modo. E soprattutto vale per COSTRUZIONE: chi aggiungera' un calendario domani non
// dovra' sapere niente di tutto questo.
export const dateConfig = {
  dateFormat: "Y-m-d",
  altInput: true,
  altFormat: "d M Y",
  locale: Italian,
  disableMobile: true,
};

export const dateTimeConfig = {
  dateFormat: "Y-m-d H:i",
  altInput: true,
  altFormat: "d M Y H:i",
  enableTime: true,
  locale: Italian,
  disableMobile: true,
};

export const timeConfig = {
  enableTime: true,
  noCalendar: true,
  dateFormat: "H:i",
  locale: Italian,
};

export const dateRangeConfig = {
  mode: "range",
  dateFormat: "Y-m-d",
  altInput: true,
  altFormat: "d M Y",
  locale: Italian,
  disableMobile: true,
};

const ALL_CONFIGS = [dateConfig, dateTimeConfig, timeConfig, dateRangeConfig];

/**
 * Allinea il calendario alla lingua dell'applicazione.
 *
 * <p>Va chiamata all'avvio e a ogni cambio lingua. Aggiorna sia le configurazioni condivise —
 * che molte viste copiano per aggiungere una data minima — sia il valore predefinito globale
 * di flatpickr, per i calendari costruiti senza passare da qui.</p>
 *
 * <p>I calendari gia' aperti non cambiano da soli: nelle viste il tag porta
 * {@code :key="$i18n.locale"}, che li fa ricostruire quando la lingua cambia.</p>
 */
export function applyFlatpickrLocale(code) {
  const locale = LOCALES[code] || LOCALES[String(code || "").slice(0, 2)] || english;
  ALL_CONFIGS.forEach((c) => { c.locale = locale; });
  flatpickr.localize(locale);
  return locale;
}

export default {
  dateConfig,
  dateTimeConfig,
  timeConfig,
  dateRangeConfig,
  applyFlatpickrLocale,
};
